// extracted by mini-css-extract-plugin
export default {"star":"review_star__EvcFZ"};